import { Option } from 'components';
declare const i18next: any;

export type ConvertToOptionsParams<T> = {
  data: T[];
  getLabel: (item: T) => string;
  getValue: (item: T) => any;
};

export const convertToOptions = <T>({
  data,
  getLabel,
  getValue,
}: ConvertToOptionsParams<T>): Option[] => {
  return data.map((item) => ({
    label: getLabel(item),
    value: getValue(item),
  }));
};

export const convertEnumToOptions = <T extends object>(
  enumObj: T,
  includeZero: boolean = false,
  prefix: string = '',
): Option[] => {
  return Object.entries(enumObj)
    .filter(([key, value]) => {
      const val = Number(value);
      return !isNaN(val) && (includeZero || !!val);
    })
    .map(([key, value]) => ({
      value: Number(value),
      label: i18next.t(`${prefix ? `${prefix}_` : ''}${String(key)}`),
    }));
};
